/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.27",
    versionName: "0.2.0-nightly.2026.2.27",
    versionChannel: "nightly",
    buildDate: "2026-02-27T00:11:54.961Z",
    commitHash: "2766e67c9f2d25467b7adfaac79f295bce1f5689",
};
